import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import TypeAheadAPI from 'dashboard/api/typeahead';

export const state = {
  records: [],
  mate: {
    total: 0,
    currentPage: 1,
    perPage: 15,
  },
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

export const getters = {
  getTypeAheadMate(_state) {
    return _state.mate;
  },
  getTypeAheadResponses(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getTypeAheadResponses(
    { commit },
    { search, page, perPage } = {}
  ) {
    commit(types.SET_TYPEAHEAD_UI_FLAG, { fetchingList: true });
    try {
      const response = await TypeAheadAPI.get({ search, page, perPage });
      commit(types.SET_TYPEAHEAD, response.data.records);
      commit(types.SET_TYPEAHEAD_MATE, response.data.meta);
      commit(types.SET_TYPEAHEAD_UI_FLAG, { fetchingList: false });
    } catch (error) {
      commit(types.SET_TYPEAHEAD_UI_FLAG, { fetchingList: false });
    }
  },

  create: async function createTypeAheadResponse({ commit }, cannedObj) {
    commit(types.SET_TYPEAHEAD_UI_FLAG, { creatingItem: true });
    try {
      const response = await TypeAheadAPI.create(cannedObj);
      commit(types.ADD_TYPEAHEAD, response.data);
      commit(types.SET_TYPEAHEAD_UI_FLAG, { creatingItem: false });
    } catch (error) {
      commit(types.SET_TYPEAHEAD_UI_FLAG, { creatingItem: false });
    }
  },

  update: async function updateTypeAheadResponse(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.SET_TYPEAHEAD_UI_FLAG, { updatingItem: true });
    try {
      const response = await TypeAheadAPI.update(id, updateObj);
      commit(types.EDIT_TYPEAHEAD, response.data);
      commit(types.SET_TYPEAHEAD_UI_FLAG, { updatingItem: false });
    } catch (error) {
      commit(types.SET_TYPEAHEAD_UI_FLAG, { updatingItem: false });
    }
  },

  delete: async function deleteTypeAheadResponse({ commit }, id) {
    commit(types.SET_TYPEAHEAD_UI_FLAG, { deletingItem: true });
    try {
      await TypeAheadAPI.delete(id);
      commit(types.DELETE_TYPEAHEAD, id);
      commit(types.SET_TYPEAHEAD_UI_FLAG, { deletingItem: false });
    } catch (error) {
      commit(types.SET_TYPEAHEAD_UI_FLAG, { deletingItem: false });
    }
  },
};

export const mutations = {
  [types.SET_TYPEAHEAD_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_TYPEAHEAD_MATE]: (_state, data) => {
    _state.mate = {
      ..._state.mate,
      ...data,
    };
  },

  [types.SET_TYPEAHEAD]: MutationHelpers.set,
  [types.ADD_TYPEAHEAD]: MutationHelpers.create,
  [types.EDIT_TYPEAHEAD]: MutationHelpers.update,
  [types.DELETE_TYPEAHEAD]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
